import React from "react";
import { Row, Col } from "antd";
import { CustomLabel, SectionCardDark } from "../../Common/style";
import { useIsTablet } from "../../Hooks";
import CONSTANTS from "../../Utils/constant";
import TEXT_CONSTANTS from "./constants";
import "./telebookingCard.css"
import { maskedEmail, maskPhoneNumber } from "../../Utils";


const TeleBookingCard = ({ appNo, date, time, mobile, email}) => {
  const isInstant = !(date && time)
  const isTablet = useIsTablet();
  return (
    <Col md={24}>
      <SectionCardDark>
        <Row gutter={[0, 18]}>
          <Col xs={24} md={12} className="member-block">
            <Row gutter={[10, 24]}>
              <Col xs={12} sm={10} md={24}>
                <CustomLabel font_size="14" font_weight="normal">
                  {TEXT_CONSTANTS?.APPLICATION_NO}
                  <b>{appNo || CONSTANTS?.NA}</b>
                </CustomLabel>
              </Col>
            </Row>
          </Col>
          <Col md={12} className="reschedule-block">
            <Row gutter={[0, { xs: 18, md: 24, lg: 24 }]}>
              {(!isTablet && !isInstant) && (
                <Col md={24} className="justify-flex-end">
                  <div className="justify-flex-center h-25">
                    <Col xs={4}>
                      <span className="start_icon" style={{ fontSize: "16px" }}>
                        <i
                          className="fa fa-calendar-check-o"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </Col>
                    <Col xs={20}>
                      <CustomLabel
                        className="ml-2"
                        font_size="14"
                        font_weight="bold"
                      >
                        {date || CONSTANTS?.NA}
                      </CustomLabel>
                    </Col>
                  </div>
                  <div className="justify-flex-center h-25 ml-4">
                    <Col xs={4}>
                      <span className="start_icon" style={{ fontSize: "18px" }}>
                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                      </span>
                    </Col>
                    <Col xs={20}>
                      <CustomLabel
                        className="ml-2"
                        font_size="14"
                        font_weight="bold"
                      >
                        {time || CONSTANTS?.NA}
                      </CustomLabel>
                    </Col>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        {(isTablet && !isInstant) && (
          <Row className="time-date-row">
            <Col xs={12} md={8}>
              <Row>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "16px" }}>
                      <i
                        className="fa fa-calendar-check-o"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {date || CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
            <Col xs={12} md={8}>
              <Row>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "18px" }}>
                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {time || CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
        )}
        <Row className="mobile-email-row">
          <Col xs={12} md={12} lg={8}>
            <Row>
              <Col xs={24}>
                <CustomLabel font_size="14" font_weight="bold">
                  {TEXT_CONSTANTS?.MOBILE_NUMBER}
                </CustomLabel>
              </Col>
              {mobile && (
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "24px" }}>
                      <i className="fa fa-mobile" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-2"
                      font_size="14"
                      font_weight="normal"
                    >
                      {mobile ? maskPhoneNumber(mobile) : CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              )}
            </Row>
          </Col>
          <Col xs={12} md={12} lg={8}>
            <Row>
              <Col xs={24}>
                <CustomLabel font_size="14" font_weight="bold">
                  {TEXT_CONSTANTS?.EMAIL_ID}
                </CustomLabel>
              </Col>
              <div className="justify-flex-center h-25">
                <Col xs={2}>
                  <span className="start_icon" style={{ fontSize: "16px" }}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </span>
                </Col>
                <Col xs={22}>
                  <CustomLabel
                    className="masked-email ml-3"
                    font_size="14"
                    font_weight="normal"
                  >
                    {email ? maskedEmail(email) : CONSTANTS?.NA}
                  </CustomLabel>
                </Col>
              </div>
            </Row>
          </Col>
          {isInstant && <Col xs={24} md={24}>
            <CustomLabel className="" font_size="14" font_weight="bold" style={{ marginTop: "24px"}}>
            {"Please Note: You will receive call in next 30 minutes."}
            </CustomLabel>
          </Col>}
        </Row>
      </SectionCardDark>
    </Col>
  );
}

export default TeleBookingCard